import React from 'react';
import intl from "react-intl-universal";
import {useRootStore, useDsManager, useAppState} from "@stores/AppStateContext";
import { useCrudServices } from "../../../../platform/hooks/useServiceCombinations";

import type {ItemModelType} from "@stores/WorkspaceStore";

import { useNotification } from "../../../hooks/useNotification";
import { TrashMenuConfirmation } from "../../ListView/TrashMenuConfirmation";
import { deleteItemForever } from "../../../../actions/item/deleteItemForever";

import './DocumentInfo.css';

export interface DocumentInfoProps {
    item: ItemModelType;
    onCancel?: () => void;
    onSubmit?: () => void;
}

export const DocumentConfirmDelete = ({ item, onCancel, onSubmit }: DocumentInfoProps) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;
    const crudServices = useCrudServices();
    const dsManager = useDsManager();
    const activeWorkspace = rootStore.view.workspace!;
    const { enqueueSnackbar } = useNotification();
    return (
        <TrashMenuConfirmation
            noHover={true}
            onCancel={() => {
                activeWorkspace.setConfirmDeleteOpen(undefined);
                onCancel && onCancel();
            }}
            mainAction={async () => {
                if (item.trashed) {
                    if (!dsManager) {
                        console.error('Data source manager is not ready for delete action');
                        return;
                    }
                    await deleteItemForever(
                        {
                            ...crudServices,
                            appState,
                        },
                        item.id,
                        rootStore.view.workspace!
                    );
                } else {
                    enqueueSnackbar({
                        variant: "warning",
                        message: intl.get('warning.deleteItemNotInTrash',).d(`Attempt to delete item that is not currently in trash`)
                    })
                }
                activeWorkspace.setConfirmDeleteOpen(undefined);
                onSubmit && onSubmit();
            }}
            mainActionText={intl.get('item-line.delete-forever').d("Delete forever")}
            headerText={
                item.isCluster
                    ? intl.get('item-line.delete-header-cluster').d("Delete cluster forever?")
                    : intl.get('item-line.delete-header-item').d("Delete page forever?")
            }
        />
    )
}
